"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scaleFactorProp = exports.scaleSpaceProps = void 0;

var _styledSystem = require("styled-system");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Append px so that the returned value is not reinterpreted
var scaleFactor = function scaleFactor(value) {
  return typeof value === "string" ? value : "".concat(value * 8, "px");
}; // MUI is more flexible with its scale factor - and we used it linearly.
// styled-system is rigid and uses a static array. The issue arises when
// we have fractional values (like 2.5) which cannot be used to access an
// array position. So convert all space values to a rationalised value.


var scaleSpaceProps = function scaleSpaceProps(props) {
  var newProps = {};
  Object.entries(props).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (_styledSystem.space.propNames.includes(key)) {
      if (_typeof(value) === "object") {
        var obj = {};
        Object.entries(value).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              objKey = _ref4[0],
              objValue = _ref4[1];

          obj[objKey] = scaleFactor(objValue);
        });
        newProps[key] = obj;
      } else {
        newProps[key] = scaleFactor(value);
      }
    } else {
      newProps[key] = value;
    }
  });
  return newProps;
}; // Take an object and return a similar object with the
// first prop's value transformed using scaleFactor


exports.scaleSpaceProps = scaleSpaceProps;

var scaleFactorProp = function scaleFactorProp(obj) {
  if (obj) {
    var value = Object.values(obj)[0];

    if (value || value === 0) {
      var key = Object.keys(obj)[0];
      var newValue = scaleFactor(obj[key]);
      return _defineProperty({}, key, newValue);
    }
  }

  return null;
};

exports.scaleFactorProp = scaleFactorProp;